<template>
  <div class="revistaentry">
    {{ item.composicao }}
  </div>
</template>

<script>
export default {
  props:["item"],
}
</script>

<style lang="scss" scoped>
.revistaentry, .revistaentry:hover{
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
  color: #707475;
  font-family: "Montserrat Semibold";
  font-size: 15px;
}
</style>